import React from "react";
import SearchBox from "../Common/Components/SearchBox.jsx";
import PanelExtended, {PanelHeader} from "../Common/Components/PanelExtended.jsx";
import TeamDetailsTableSimple from "../TeamDetails/Components/TeamDetailsTableSimple.jsx";
import {FormattedMessage} from "react-intl";

const HthTeam = ({
    team,
    teamsList,
    columns,
    showList,
    position,
    onSearch,
    otherTeam,
    onTeamClick,
    subleagues,
    subleaguesOpen,
    classifications,
    searchMore,
    ownTeams
}) => {
    return <PanelExtended>
        <PanelHeader className="head-to-head__team-header">
            <HthSearch {...{
                classifications,
                subleagues,
                subleaguesOpen,
                teamsList,
                showList,
                onTeamClick,
                onSearch,
                position,
                more: searchMore,
                ownTeams
            }}/>
            {team ? <h2 className="module__title">{team.name}</h2> : null}
        </PanelHeader>
        <div className="head-to-head__table-wrap">
        <TeamDetailsTableSimple
            mark={otherTeam}
            team={team}
            columns={columns}
        />
        </div>
    </PanelExtended>
};

class HthSearch extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            subleague: 0,
            subleagueOpen: 0,
            classification: this.props.classifications[0].id,
            from: 0,
            showList: false,
            search: null,
            teams: this.props.teamsList && this.props.teamsList.map(e => ({...e, nameLower: e.name.toLowerCase()})) || null,
            ownTeams: this.props.ownTeams && this.props.ownTeams.map(e => ({...e, nameLower: e.name.toLowerCase()})) || null,
            showOwnTeams: false
        };
        this.hideTimer = null;
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMore = this.handleMore.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleShowOwnTeams = this.handleShowOwnTeams.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            teams:nextProps.teamsList && nextProps.teamsList.map(e => ({...e, nameLower: e.name.toLowerCase()})) || null
        })
    }


    handleFocus(e) {
        if (this.state.showOwnTeams) {
            if (e.target.tagName !== 'INPUT') {
                return;
            }
        }

        if (this.hideTimer) {
            clearInterval(this.hideTimer);
        }

        if (!this.state.teams) {
            this.handleSearch(null, true);
        }
        this.setState({showList: true, showOwnTeams: false});
    }

    handleBlur() {
        clearInterval(this.hideTimer);
        this.hideTimer = setTimeout(() =>
            this.setState({showList: false}), 5
        );
    }

    handleSearch(search, force) {
        search = search && search.toLowerCase();
        this.setState({from: 0, search: search, showOwnTeams: false});
        if(force || this.props.more) {
            this.props.onSearch(this.props.position, this.state.classification, this.state.subleague, this.state.subleagueOpen)
        }
    }

    search({classification, subleague, subleagueOpen}) {
        this.props.onSearch(this.props.position, classification, subleague, subleagueOpen)
    }

    handleMore(direction) {
        this.setState(prevState => ({from: prevState.from + 15 * direction}))
    }

    handleClick(teamId) {
        this.props.onTeamClick(teamId, this.props.position);
        this.setState({showList: false});
    }

    handleShowOwnTeams() {
        clearInterval(this.hideTimer);
        this.setState(prevState => ({
            showOwnTeams: !prevState.showOwnTeams, showList:!prevState.showOwnTeams
        }));
    }

    handleChange(target, value) {
        this.setState(prevState => {
            let newState = {...prevState, [target]: Number(value), showOwnTeams: false};
            if (target == 'subleague') {
                newState.subleagueOpen = 0;
            }
            if (target == 'subleagueOpen') {
                newState.subleague = 0;
            }
            this.search(newState);
            return newState
        });
    }

    getFilteredTeams() {
        if(this.state.showOwnTeams) {
            return this.state.ownTeams;
        }
        if(!this.state.teams) {
            return [];
        }

        if(!this.state.search) {
            return this.state.teams || []
        }
        return this.state.teams.filter(e => e.name.toLowerCase().includes(this.state.search)) || [];
    }

    getPage(filteredTeams) {
        return filteredTeams.slice(this.state.from, this.state.from + 15) || [];
    }

    getMore(filteredTeams) {
        return !this.state.showOwnTeams && this.state.teams && this.state.from + 15 < filteredTeams.length
    }

    getFetchMore(filteredTeams) {
        if (this.state.showOwnTeams || this.state.subleagueOpen || this.state.subleague || this.props.more || !this.state.search) {
            return false;
        }
        return !this.getMore(filteredTeams)
    }

    render() {
        const allTeams = this.getFilteredTeams();
        const teams = this.getPage(allTeams);
        return <div className="hth-search">
            <FormattedMessage id="hth.selectPrizeSubleague">
                {message =>
                    <HthSearchOption
                        items={this.props.subleagues}
                        value={this.state.subleague}
                        onChange={val => this.handleChange('subleague', val)}
                        placeholder={message}/>
                }
            </FormattedMessage>
            <FormattedMessage id="hth.selectOpenSubleague">
                {message =>
                    <HthSearchOption
                        items={this.props.subleaguesOpen}
                        value={this.state.subleagueOpen}
                        onChange={val => this.handleChange('subleagueOpen', val)}
                        placeholder={message}/>
                }
            </FormattedMessage>
            <HthSearchOption items={this.props.classifications}
                             value={this.state.classification}
                             onChange={val => this.handleChange('classification', val)}/>
            {this.state.ownTeams ? <button className="hth-search__button" onClick={this.handleShowOwnTeams}><FormattedMessage id={this.state.showOwnTeams ? "hth.hideOwnTeams" : "hth.showOwnTeams"}/></button> : null}
            <div onFocus={this.handleFocus}
                 onBlur={this.handleBlur}>
                <FormattedMessage id="hth.searchPlaceholder">
                    {message => <SearchBox onSearch={this.handleSearch} onKeyPress={this.handleSearch} placeholder={message}/>}
                </FormattedMessage>
                <HthSearchPopupList
                    teams={teams}
                    more={this.getMore(allTeams)}
                    less={!this.state.showOwnTeams && this.state.from > 0}
                    onMore={this.handleMore}
                    show={this.state.showList}
                    onClick={this.handleClick}
                />
            </div>
        </div>
    }
}

const HthSearchOption = ({items, onChange, value, placeholder}) => {
    if (!items || !items.length) {
        return null;
    }
    return <select className="hth-search__input" onChange={e =>onChange(e.target.value)} value={value}>
        {placeholder ? <option value={0}>{placeholder}</option> : null}
        {
            items.map(
                item => <option value={item.id} key={item.id}>{item.name}</option>
            )
        }</select>
};

const HthSearchPopupList = ({show, teams, onClick, more, less, onMore}) => {
    if (!show) {
        return null;
    }

    if (!teams.length) {
        return <div className="hth-search__list">
            <div className="hth-search__item"><FormattedMessage id="hth.noTeams"/></div>
        </div>
    }

    return <div className="hth-search__list">
        {less ? <button className="hth-search__item" onClick={() => onMore(-1)}><FormattedMessage id="app.showMore"/>
        </button> : null}
        {teams.map(
            team =>
                <button className="hth-search__item"
                        key={team.id}
                        onClick={() => onClick(team.id)}>
                    {team.name + (team.points ? ` (${team.points})`:'')}
                </button>)}
        {more ? <button className="hth-search__item" onClick={() => onMore(1)}><FormattedMessage id="app.showMore"/>
        </button> : null}
    </div>
};

 export default HthTeam